<img *ngIf="imageSrc; else noImage" class="uc-avatar-img" loading="lazy" alt="" [src]="imageSrc" (error)="onImageError()">
<ng-template #noImage>
  <span *ngIf="initials; else iconAvatar" class="uc-avatar-initials" aria-hidden="true">{{ initials }}</span>
</ng-template>
<ng-template #iconAvatar>
  <i class="uc-avatar-icon fa-solid" [ngClass]="icon" aria-hidden="true"></i>
</ng-template>
